import request from '@/config/axios'

export type TprVO = {
  id: number
  category: string
  chinese: string
  english: string
  coverUrl: string
  videoUrl: string
}

export const getTprList = (params: any) => {
  return request.get({
    url: '/tpr/list',
    params
  })
}
